export function avatar_initials(name: string | null | undefined, email: string | null | undefined): string {
  const from_name = String(name || '').trim()
  if (from_name) {
    const parts = from_name.split(/\s+/).filter(Boolean)
    if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
    return from_name.slice(0, 2).toUpperCase()
  }
  const mail = String(email || '').trim()
  if (mail) return mail.slice(0, 2).toUpperCase()
  return '??'
}

export function avatar_src(url: string | null | undefined): string | null {
  const raw = String(url || '').trim()
  if (!raw) return null
  if (raw.startsWith('/api/auth/avatar')) return raw
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw
  return null
}

export function avatar_html(opts: {
  url?: string | null
  name?: string | null
  email?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** No topbar escuro: fundo/legenda claros para não “sumir”. */
  topbar?: boolean
}): string {
  const size = opts.size || 'md'
  const box =
    size === 'sm' ? 'h-8 w-8 text-[10px]' : size === 'lg' ? 'h-12 w-12 text-sm' : 'h-9 w-9 text-xs'
  const src = avatar_src(opts.url)
  const initials = avatar_initials(opts.name, opts.email)
  const extra = opts.className ? ` ${opts.className}` : ''
  const initials_cls = opts.topbar
    ? 'bg-white/20 font-semibold text-white ring-1 ring-white/35'
    : 'bg-brand/15 font-semibold text-brand ring-1 ring-border'

  if (src) {
    const safe = src.replace(/"/g, '&quot;')
    // onerror: imagem sumiu (migração/path) → troca por iniciais
    const safe_initials = initials.replace(/[^A-Za-z0-9]/g, '').slice(0, 2) || '??'
    return `<span class="inline-grid ${box} shrink-0 place-items-center overflow-hidden rounded-sm ${initials_cls}${extra}" data-avatar-host>
      <img src="${safe}" alt="" class="h-full w-full object-cover" referrerpolicy="no-referrer" loading="lazy"
        onerror="var p=this.parentElement;this.remove();if(p){p.textContent='${safe_initials}'}" />
    </span>`
  }

  return `<span class="inline-grid ${box} shrink-0 place-items-center rounded-sm ${initials_cls}${extra}">${initials}</span>`
}